import { CommonModule, Location } from '@angular/common';
import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { PymesInfoProductoData, PymesInfoProductoColumn } from '../../../../interfaces/infoProfuct.interface';

@Component({
	selector: 'app-pymes-info-producto',
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		CaButtonComponent
	],
	templateUrl: './pymes-info-producto.component.html',
	styleUrls: ['./pymes-info-producto.component.scss']
})

export class PymesInfoProductoComponent implements OnInit {
	id: string | null = null;
	productInfo: PymesInfoProductoData | null = null;

	@Input() data: { infoProducto?: string } | null = null;

	typeData = {
		'Salud Médica Pyme': 'MEDICA',
		'Salud Prestigio Pyme': 'PRESTIGIO',
		'Salud Integral Pyme (Menos de 20 asegurados)': 'INTEGRAL',
		'Salud Integral Pyme (Más de 20 asegurados)': 'INTEGRAL'
	};


	private route = inject(ActivatedRoute);
	private destroyRef = inject(DestroyRef);
	private translateService = inject(TranslateService);

	constructor() { }

	ngOnInit(): void {
		this.selectIdType()
		this.loadProductInfoById();
	}

	selectIdType() {
		this.id = this.data?.infoProducto ?? this.route.snapshot.paramMap.get('id');
		if (!this.id) {
			return;
		}
		this.id = this.typeData[this.id];

	}

	private loadProductInfoById(): void {
		if (!this.id) {
			return;
		}

		this.translateService
			.stream(`PYMES.INFO-PRODUCTO.${this.id}`)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((data: PymesInfoProductoData | string) => {
				if (typeof data === 'string') {
					this.productInfo = null;
					return;
				}
				this.productInfo = data;
			});
	}

	trackByColumn(index: number, column: PymesInfoProductoColumn): string {
		return `${column.TITLE}-${column.SUBTITLE}-${index}`;
	}

	trackByItem(index: number): number {
		return index;
	}

	trackByPart(index: number): number {
		return index;
	}
}